import {
    faAddressBook,
    faInbox,
    faCamera,
    faChartLine,
    faClipboardList,
    faCopy,
    faExpandArrowsAlt,
    faEye,
    faFileAlt,
    faImage,
    faImages,
    faListAlt,
    faUpload,
    faSignOutAlt,
    faKeyboard,
    faRetweet,
    faSearch,
    faUsers,
    faBoxOpen,
    faBoxesStacked,
    faClipboardCheck,
    //faDesktop,
} from "@fortawesome/free-solid-svg-icons";
import { TASK_PERMISSIONS } from "shared/constants";

export const links = [
    {
        path: "/shipments",
        label: "Shipments",
        icon: faInbox,
        activePaths: ["/digital-shipment-editor", "/shipment-editor"],
    },
    {
        path: "/duplicate-staging",
        label: "Duplicate Staging",
        icon: faBoxesStacked,
        activePaths: ["/duplicate-staging/"],
    },
    { path: "/task-list/photography", label: "Photography", icon: faCamera, activePaths: ["/photography/"] },
    { path: "/profiling", label: "Profiling", icon: faClipboardList, activePaths: ["/profiling/", "/scheduling/"] },
    { path: "/task-list/coding", label: "Coding", icon: faFileAlt, activePaths: ["/coding/"] },
    { path: "/task-list/codingqa", label: "Coding QA", icon: faCopy, activePaths: ["/coding-qa/"] },
    { path: "/task-list/imageediting", label: "Image Editing", icon: faImage, activePaths: ["/image-editing/"] },
    {
        path: "/task-list/imageeditingqa",
        label: "Image Editing QA",
        icon: faImages,
        activePaths: ["/image-editing-qa/"],
    },
    { path: "/tools/bin-mover", label: "Bin Mover", icon: faExpandArrowsAlt, activePaths: [] },
    { path: "/task-list/finalqa", label: "Final QA", icon: faEye, activePaths: ["/final-qa/"] },
    {
        path: "/task-list/brandverifiedqa",
        label: "Brand Verified QA",
        icon: faClipboardCheck,
        activePaths: ["/brand-verified-qa/"],
        allowedPermission: TASK_PERMISSIONS.viewBrandVerifiedQa,
    },
    { path: "/tools/search", label: "Search", icon: faSearch, activePaths: [] },
    { path: "/logout", label: "Logout", icon: faSignOutAlt, activePaths: [] },
];

export const adminLinks = [
    { path: "/admin", label: "Dashboard", icon: faChartLine, activePaths: [] },
    { path: "/admin/resubmit-upc", label: "Resubmit UPC", icon: faRetweet, activePaths: [] },
    { path: "/admin/upc-search", label: "Upc Search", icon: faSearch, activePaths: [] },
    { path: "/admin/assignment/tasks", label: "Assignment", icon: faClipboardList, activePaths: [] },
    { path: "/admin/clients/settings", label: "Client Settings", icon: faAddressBook, activePaths: ["/admin/clients/settings"] },
    { path: "/admin/users", label: "Users & Roles", icon: faUsers, activePaths: [] },
    {
        path: "/admin/attributes/picklist-data",
        label: "Attributes",
        icon: faBoxOpen,
        activePaths: ["/admin/picklist-data"],
    },
    //{ path: "/admin/monitoring", label: "Monitoring", icon: faDesktop, activePaths: [] },
    { path: "/", label: "Intake", icon: faKeyboard, activePaths: [] },
    { path: "/logout", label: "Logout", icon: faSignOutAlt, activePaths: [] },
];

export const preshipmentLinks = [
    { path: "/preshipment", label: "Preshipment", icon: faListAlt, activePaths: [] },
    { path: "/preshipment/search-upc", label: "Search UPC", icon: faSearch, activePaths: [] },
    { path: "/preshipment/upload-content", label: "Upload Content", icon: faUpload, activePaths: [] },
    { path: "/logout", label: "Logout", icon: faSignOutAlt, activePaths: [] },
];
